// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"4b564c41","605":"52875f31"}[chunkId] + ".chunk.js";
};